<template>
  <div id="share-component">
    <div class="share-project" v-if="shareProject">
      <input
        type="text"
        placeholder="Share this with (enter one email at a time)"
        v-model="email"
        @keydown="shareWith"
      >
    </div>
    <p v-if="queuedUsers.length > 0">
      <span
        :id="user.email"
        @click="removeUser"
        class="project-users"
        v-for="user in queuedUsers"
        :key="user.userId"
      >{{ user.name }}</span>
    </p>
    <span class="message">{{ message }}</span>
    <button v-if="queuedUsers.length > 0" @click="commitSave">Add users</button>
  </div>
</template>

<script>
import db from "@/fb/init";

export default {
  name: "ShareComponent",
  props: ["shareProject", "board"],
  data() {
    return {
      email: null,
      alreadyChecked: [],
      queuedUsers: [],
      mergedUsers: null,
      message: null
    };
  },
  methods: {
    async getUser(email) {
      let user = null;
      let usersRef = db.collection("users");
      let emailRef = usersRef.where("email", "==", email);
      let snapShot = await emailRef.get();
      if (!snapShot.empty) {
        snapShot.forEach(doc => {
          if (!doc.empty) {
            user = doc.data();
            user.userId = doc.id;
          }
        });
      }
      return user;
    },
    shareWith(e) {
      if (e.which === 27) {
        this.$emit("hideShare");
        this.message = null;
      } else if (e.which === 13) {
        const email = this.email;
        this.email = null;
        if (!this.alreadyChecked.includes(email) && email !== "") {
          this.alreadyChecked.push(email);
          this.getUser(email).then(user => {
            this.saveUser(user);
          });
        }
      }
    },
    saveUser(user) {
      this.message = null;
      if (user) {
        this.queuedUsers.push(user);
      } else {
        this.message = "No such user";
      }
    },

    removeUser(e) {
      const id = e.target.id;
      const index1 = this.queuedUsers.findIndex(el => el.email === id);
      this.queuedUsers.splice(index1, 1);
      const index2 = this.alreadyChecked.findIndex(el => el === id);
      this.alreadyChecked.splice(index2, 1);
    },

    reconcileUsers() {
      if (this.board.sharedUsers) {
        this.mergedUsers = this.board.sharedUsers.concat(this.queuedUsers);
      } else {
        this.mergedUsers = this.queuedUsers;
      }
    },

    commitSave() {
      this.reconcileUsers();
      db.collection("boards")
        .doc(this.board.board_id)
        .set(
          {
            sharedUsers: this.mergedUsers
          },
          { merge: true }
        )
        .then(() => {
          this.queuedUsers = [];
          this.mergedUsers = null;
          this.alreadyChecked = [];
          this.$emit("hideShare");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#share-component {
  top: 150px;
  background-color: white;
  opacity: 1;
  border: 1px solid #eee;
  border-radius: 5px;
  z-index: 1000;
  position: absolute;
  box-shadow: 1px 2px 3px 2px #eee;

  .share-project {
    text-align: center;

    input {
      width: 322px;
      border: 1px solid #eee;
      border-radius: 5px;
      font-size: inherit;
      padding: 0.5rem;
      margin-bottom: 0.5rem;
    } // input
  } // .share-project

  .project-users {
    border: 1px solid #eee;
    background-color: #eee;
    border-radius: 5px;
    font-weight: 800;
    padding: 0.5rem 1rem;
    margin: 0 0.5rem;
    &:hover {
      background-color: rgb(133, 68, 68);
      color: white;
      cursor: pointer;
    } // &:hover
  } // .project-users
  .message {
    display: block;
    text-align: center;
    color: rgb(133, 68, 68);
  } // .message
} // share-component
</style>
